export default {
  'meta': {
    'langName': 'POLISH',
    'lang': 'Polski'
  },
  'title': 'ALERT DOT. PRODUKTU: KOSZ DO KOSZYKÓWKI B900 BOX NBA TARMAK',
  'description': 'Szanowni Państwo,\n\n\nDziękujemy za zakup kosza do koszykówki Tarmak B900 BOX NBA.\n\n\nW ramach nieustannego dążenia do zapewnienia najwyższej jakości i bezpieczeństwa naszych produktów, zespół DECATHLON Basket stwierdził ryzyko pionowego upadku słupa w przypadku zdjęcia korby do regulacji wysokości i przenoszenia lub użytkowania produktu.\n\n\nProsimy o udzielenie odpowiedzi na poniższe pytania, abyśmy mogli zapewnić Państwu rozwiązanie zapewniające bezpieczeństwo produktu.\n\n\nPrzepraszamy za niedogodności i dziękujemy za zaufanie.\n\n\nDECATHLON',
  'emailConfirmation': {
    'title': 'Najpierw poprosimy o potwierdzenie adresu e-mail i kraju zamieszkania:'
  },
  'fields': {
    'country': 'Kraj',
    'address': 'Adres e-mail',
    'email': 'Adres e-mail',
    'phonePrefix': 'Numer kierunkowy',
    'phone': 'Numer telefonu',
    'validations': {
      'phoneOrEmail': 'Prosimy o podanie co najmniej adresu e-mail LUB numeru telefonu',
      'email': 'Wprowadź prawidłowy adres e-mail',
      'phone': 'Wprowadź prawidłowy numer telefonu'
    },
    'firstName': 'Nazwisko',
    'lastName': 'Imię',
    'deliveryAddress': 'Adres',
    'additionalAddress': 'Dodatkowe dane adresowe',
    'city': 'Miasto',
    'zip': 'Kod pocztowy',
    'choose': 'Wybierz',
    'required': 'To pole jest obowiązkowe'
  },
  'ownerCheck': {
    'title': 'Czy nadal posiadasz jeden lub więcej koszy do koszykówki Tarmak B900 BOX NBA?'
  },
  'yes': 'TAK',
  'no': 'NIE',
  'ownerChanged': {
    'title': 'Czy posiadasz dane kontaktowe obecnego właściciela lub właścicieli?',
    'confirmation': 'Szanowny Kliencie / Klientko,\n\nDziękujemy za udział w tej procedurze dot. jakości produktów.\n\nPrzepraszamy za niedogodności i dziękujemy za zaufanie.\n\nDECATHLON'
  },
  'recall': {
    'title': 'Podaj liczbę posiadanych koszy do koszykówki w zależności od rodzaju zainstalowanej korby',
    'descriptionRed': 'Kosz do koszykówki z wyjmowaną czerwoną korbą',
    'descriptionBlack': 'Kosz do koszykówki z czarną korbą zainstalowaną na stałe',
    'quantity': 'Ilość',
    'notConcerned': 'Szanowny Kliencie / Klientko,\n\nDziękujemy za udział w tej procedurze dot. jakości produktów.\n\nInformujemy, że Twój kosz do koszykówki Tarmak B900 BOX NBA nie jest objęty alertem i można go używać w pełni bezpiecznie.\n\nPrzepraszamy za niedogodności i dziękujemy za zaufanie.\n\nDECATHLON',
    'concernedProductQuantity': 'Liczba produktów niespełniających wymogów:',
    'concernedProductLabel': 'Produkt niespełniający wymogów:',
    'confirmation': 'Dziękujemy za wypełnienie formularza. Twoje zgłoszenie zostało zarejestrowane.\n\nW najbliższym możliwym terminie przekażemy Ci numer przesyłki z zestawem naprawczym.\n\nŻyczymy miłego dnia,\n\nDECATHLON\n'
  },
  'repair': {
    'title': 'Naprawa z Twoim udziałem',
    'description': 'Stwierdziliśmy ryzyko pionowego upadku słupa w przypadku wyjęcia korby i przenoszenia lub użytkowania niektórych koszy do koszykówki TARMAK B900 BOX NBA, kod produktu: 4239136.\nBiorąc pod uwagę Twoją odpowiedź, wydaje się, że ten problem dotyczy również Twojego produktu.\n\nW związku z tym prosimy o zaprzestanie użytkowania produktu i oferujemy pomoc w dostosowaniu tej korby, aby zagwarantować w pełni bezpieczne użytkowanie produktu.\nZapewniamy, że naprawa nie wymaga żadnej specjalistycznej wiedzy. Wszystko jest dokładnie opisane w filmie instruktażowym i instrukcji poniżej:',
    'videoLink': 'Link do filmu instruktażowego',
    'docLink': 'Link do instrukcji',
    'callToAction': 'Kliknij tutaj, aby otrzymać bezpłatny zestaw do naprawy',
    'warranty': 'Cały proces objęty jest naszą 5-letnią gwarancją.'
  },
  'repairRequest': {
    'title': 'Prosimy o podanie poniższych informacji, abyśmy mogli wysłać Ci bezpłatny zestaw na wybrany przez Ciebie adres:'
  },
  'form': {
    'submit': 'Dalej'
  },
  'status': 'Translation validated by COUNTRY'
} as const
